import { render, staticRenderFns } from "./ResultsWrapper.vue?vue&type=template&id=348d1f6a&scoped=true"
import script from "./ResultsWrapper.js?vue&type=script&lang=js&external"
export * from "./ResultsWrapper.js?vue&type=script&lang=js&external"
import style0 from "./ResultsWrapper.scss?vue&type=style&index=0&id=348d1f6a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348d1f6a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CircleLoader: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/common/CircleLoader.vue').default,WordListInterlinkDirector: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/results/WordListInterlinkDirector/WordListInterlinkDirector.vue').default})
